import React, { useState } from "react";
// import { ReactComponent as Logo } from "../../../src/assets/images/logo.png";
import  Logo  from "../../../src/assets/images/logo.png";
import { useLocation, useNavigate } from "react-router-dom";
import {
  MenuOutlined,
} from '@ant-design/icons';
import { Drawer } from "antd";
export const Header = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const [drawerVisibility,setDrawerVisibility]=useState(false)
  console.log("location", location.pathname)
  const [hovered, setHovered] = useState(null);
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        height: 70,
        padding: "0px 20px",
        width: "90%",
      }}
    >
      {/* <Logo /> */}
      <div><img style={{width:200,height:70,cursor:"pointer"}} onClick={()=>navigate("/")} src={Logo}/></div>
      {window.innerWidth>1000 ? <div style={{ display: "flex", gap: 30, fontSize: 18,fontWeight:400, color: "#FFF" }}>
        <div
          style={{
            cursor: "pointer",
            background: location.pathname === "/" ? "#f7941d" : "#151515",
            borderRadius: 8,
            width: "80px", // Add width
            height:35, // Add height
            display: "flex", // Center content horizontally and vertically
            alignItems: "center",
            justifyContent: "center",
            borderBottom: hovered === "home" ? "2px solid #e04c08" : "none",
            transition: "all 0.3s ease"
          }}
          onClick={() => navigate("/")}
          onMouseEnter={() => setHovered("home")}
          onMouseLeave={() => setHovered(null)}
        >
          Home
        </div>
        <div
          style={{
            cursor: "pointer",
            background: location.pathname === "/why_thy" ? "#f7941d" : "#151515",
            borderRadius: 8,
            width: "110px", // Add width
            height:35, // Add height
            display: "flex", // Center content horizontally and vertically
            alignItems: "center",
            justifyContent: "center",
            borderBottom: hovered === "why_thy" ? "2px solid #e04c08" : "none",
            transition: "all 0.3s ease"
          }}
          onClick={() => navigate("/why_thy")}
          onMouseEnter={() => setHovered("why_thy")}
          onMouseLeave={() => setHovered(null)}
        >
          Why THY?
        </div>
        <div
          style={{
            cursor: "pointer",
            background: location.pathname === "/services" ? "#f7941d" : "#151515",
            borderRadius: 8,
            width: "95px", // Add width
            height:35, // Add height
            display: "flex", // Center content horizontally and vertically
            alignItems: "center",
            justifyContent: "center",
            borderBottom: hovered === "services" ? "2px solid #e04c08" : "none",
            transition: "all 0.3s ease"
          }}
          onClick={() => navigate("/services")}
          onMouseEnter={() => setHovered("services")}
          onMouseLeave={() => setHovered(null)}
        >
          Services
        </div>
        <div
          style={{
            cursor: "pointer",
            background: location.pathname === "/products" ? "#f7941d" : "#151515",
            borderRadius: 8,
            width: "95px", // Add width
            height:35, // Add height
            display: "flex", // Center content horizontally and vertically
            alignItems: "center",
            justifyContent: "center",
            borderBottom: hovered === "products" ? "2px solid #e04c08" : "none",
            transition: "all 0.3s ease"
          }}
          onClick={() => navigate("/products")}
          onMouseEnter={() => setHovered("products")}
          onMouseLeave={() => setHovered(null)}
        >
          Products
        </div>
        <div
          style={{
            cursor: "pointer",
            background: location.pathname === "/contact_us" ? "#f7941d" : "#151515",
            borderRadius: 8,
            width: "120px", // Add width
            height:35, // Add height
            display: "flex", // Center content horizontally and vertically
            alignItems: "center",
            justifyContent: "center",
            borderBottom: hovered === "contact_us" ? "2px solid #e04c08" : "none",
            transition: "all 0.3s ease"
          }}
          onClick={() => navigate("/contact_us")}
          onMouseEnter={() => setHovered("contact_us")}
          onMouseLeave={() => setHovered(null)}
        >
          Contact Us!
        </div>
      </div> : 
      <div
      style={{
        border: "2px solid #ffffff",
        borderRadius: "50%",
        width: 25,
        height: 25,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        background: "#151515"
      }}
      onClick={() => setDrawerVisibility(true)}
    >
      <MenuOutlined style={{ fontSize: 15, color: "#ffffff" }} />
    </div>}
     
        <Drawer
        closable
        destroyOnClose
        title={<p>Explore More</p>}
        placement="right"
        open={drawerVisibility}
        style={{width:500}}
        onClose={() => setDrawerVisibility(false)}
      >
        <div style={{display:"flex",flexDirection:"column",gap:20,fontSize:20}}>
          <div onClick={()=>navigate("/")}>Home</div>
          <div onClick={() => navigate("/why_thy")}>Why THY?</div>
          <div  onClick={() => navigate("/services")}>Services</div>
          <div  onClick={() => navigate("/products")}>Products</div>
          <div   onClick={() => navigate("/contact_us")}>Contact Us</div>
        </div>
      </Drawer>
    </div>
  )
}